"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cosmos_1 = require("components/cosmos");
const translate_1 = require("components/translate");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const folderItem_1 = require("../../components/folderItem");
const folderService_1 = __importDefault(require("../../services/folderService"));
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const FolderList = ({ t, PlayerBackofficeStore, searchTerm }) => {
    const [items, setItems] = (0, react_1.useState)([]);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [fetchFolderData, setFetchFolderData] = (0, react_1.useState)({
        page: 0,
        folderData: {}
    });
    const [totalMediasAmount, setTotalMediasAmount] = (0, react_1.useState)(0);
    const searchTermRef = (0, react_1.useRef)(searchTerm);
    const isFirstLoad = (0, react_1.useRef)(true);
    const [openedFolder, setOpenedFolder] = (0, react_1.useState)([]);
    const loader = (0, react_1.useRef)(null);
    const getFolderName = (folder) => folder.isDefaultFolder
        ? t('player_backoffice.file_explorer.default_folder_library_name')
        : folder.name;
    const resetItems = (0, react_1.useCallback)(() => {
        setItems([]);
        setHasMore(false);
    }, []);
    const fetchItems = (0, react_1.useCallback)(({ page, folderData: folder }) => {
        var _a;
        setIsLoading(true);
        const isSearching = searchTermRef.current &&
            searchTermRef.current.length > 0 &&
            !((_a = fetchFolderData.folderData) === null || _a === void 0 ? void 0 : _a.code);
        const query = isSearching
            ? folderService_1.default.searchItems(String(searchTermRef.current), { page })
            : folderService_1.default.getFolderByCode({ page, folderData: folder });
        query
            .then((folderResponse) => {
            setItems((prevItems) => {
                var _a;
                return [
                    ...(((_a = fetchFolderData.folderData) === null || _a === void 0 ? void 0 : _a.code) === (folder === null || folder === void 0 ? void 0 : folder.code)
                        ? prevItems
                        : []),
                    ...folderResponse.content
                ];
            });
            setHasMore(folderResponse.totalPages - 1 > page);
            setTotalMediasAmount(folderResponse.totalElements);
        })
            .finally(() => {
            setIsLoading(false);
        });
    }, [fetchFolderData]);
    (0, react_1.useEffect)(() => {
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            return;
        }
        fetchItems(fetchFolderData);
    }, [fetchFolderData, fetchItems]);
    (0, react_1.useEffect)(function deselectMediaWhenFolderItemsIsEmpty() {
        if (items.length === 0) {
            PlayerBackofficeStore.deselectMedia();
        }
    }, [PlayerBackofficeStore, items]);
    (0, react_1.useEffect)(function onSearchTermChange() {
        resetItems();
        setOpenedFolder([]);
        setFetchFolderData({
            page: 0,
            folderData: {}
        });
        searchTermRef.current = searchTerm;
    }, [searchTerm, resetItems]);
    (0, react_1.useEffect)(function onListItemsScroll() {
        const loaderElement = loader.current;
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore) {
                setFetchFolderData((prev) => ({ ...prev, page: prev.page + 1 }));
            }
        }, {
            threshold: 1
        });
        if (loaderElement) {
            observer.observe(loaderElement);
        }
        return () => {
            if (loaderElement) {
                observer.unobserve(loaderElement);
            }
        };
    }, [hasMore]);
    const handleFolderItemClick = (item) => {
        if (item.category === 'folder') {
            resetItems();
            setOpenedFolder((prev) => [
                ...prev,
                {
                    ...fetchFolderData.folderData,
                    name: getFolderName(item)
                }
            ]);
            setFetchFolderData({
                folderData: item,
                page: 0
            });
            return;
        }
        PlayerBackofficeStore.selectMedia(item);
    };
    const handleBackToParentFolder = (item) => {
        resetItems();
        setOpenedFolder((prev) => prev.slice(0, -1));
        setFetchFolderData({
            folderData: item,
            page: 0
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "_text-gray-500 _pl-4", children: t('player_backoffice.file_explorer.search_result', {
                    data: {
                        amount: totalMediasAmount
                    }
                }) }), openedFolder.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cosmos_1.Button, { variation: "tertiary", icon: ['fal', 'arrow-left'], className: (0, classnames_1.default)(styles_module_scss_1.default.backButton, '_text-gray-900'), onClick: () => handleBackToParentFolder(openedFolder[openedFolder.length - 1]), children: getFolderName(openedFolder[openedFolder.length - 1]) }), (0, jsx_runtime_1.jsx)("hr", { className: "_border-gray-300 _mb-2 _mt-0 _border-bottom _border-top-0 _border-left-0 _border-right-0 _w-full" })] })), (0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(styles_module_scss_1.default.list, '_overflow-y-auto'), children: [items.map((item) => {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(folderItem_1.FolderItem, { type: item.category, active: ((_a = PlayerBackofficeStore.selectedMedia) === null || _a === void 0 ? void 0 : _a.code) === item.code, title: getFolderName(item), onClick: () => handleFolderItemClick(item) }, item.code));
                    }), (hasMore || isLoading) && ((0, jsx_runtime_1.jsx)("div", { ref: loader, "data-test": "loader-content", style: { height: '10px' }, children: (0, jsx_runtime_1.jsx)(cosmos_1.Loading, { center: true }) }))] })] }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    PlayerBackofficeStore: stores.PlayerBackofficeStore
})))(FolderList);
